export class FilterConfig {
    constructor(
        public enabled = false
    ) { }
}
